import CitiesSelector from './cities-selector.vue'

export default CitiesSelector
